/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup } from './GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup';
import {
    GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupFromJSON,
    GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupFromJSONTyped,
    GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupToJSON,
} from './GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetQaEquipmentSetupTemplateDto
 */
export interface GetQaEquipmentSetupTemplateDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetQaEquipmentSetupTemplateDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetQaEquipmentSetupTemplateDto
     */
    supportSystemEntityIds: Array<string>;
    /**
     * 
     * @type {GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup}
     * @memberof GetQaEquipmentSetupTemplateDto
     */
    previousQaEquipmentSetup?: GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup | null;
    /**
     * 
     * @type {string}
     * @memberof GetQaEquipmentSetupTemplateDto
     */
    $type?: GetQaEquipmentSetupTemplateDtoTypeEnum;
}


/**
 * @export
 */
export const GetQaEquipmentSetupTemplateDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetQaEquipmentSetupTemplateDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetQaEquipmentSetupTemplateDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetQaEquipmentSetupTemplateDtoTypeEnum = typeof GetQaEquipmentSetupTemplateDtoTypeEnum[keyof typeof GetQaEquipmentSetupTemplateDtoTypeEnum];


/**
 * Check if a given object implements the GetQaEquipmentSetupTemplateDto interface.
 */
export function instanceOfGetQaEquipmentSetupTemplateDto(value?: unknown): value is GetQaEquipmentSetupTemplateDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetQaEquipmentSetupTemplateDtoTypeEnum)[0];
}

export function GetQaEquipmentSetupTemplateDtoFromJSON(json: any): GetQaEquipmentSetupTemplateDto {
    return GetQaEquipmentSetupTemplateDtoFromJSONTyped(json, false);
}

export function GetQaEquipmentSetupTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQaEquipmentSetupTemplateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'supportSystemEntityIds': json['supportSystemEntityIds'],
        'previousQaEquipmentSetup': !exists(json, 'previousQaEquipmentSetup') ? undefined : GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupFromJSON(json['previousQaEquipmentSetup']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetQaEquipmentSetupTemplateDtoToJSON(value?: GetQaEquipmentSetupTemplateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'supportSystemEntityIds': value.supportSystemEntityIds,
        'previousQaEquipmentSetup': GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupToJSON(value.previousQaEquipmentSetup),
        '$type': value.$type,
    });
}

